import {useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import {CompanyBenefits} from './CompanyBenefits';
import {CompanyLocations} from './CompanyLocations';
import {CompanySummary} from './CompanySummary';
import {MediaCarousel, MediaResource} from '../../../../../components/Carousel/Carousel';
import {CompanyProfile, MediaProfile} from '../../../../company/profile/types';
import {MatchLocation} from '../../../dashboard/types/ApplicantMatchesTypes';

interface Props {
  companyProfile: CompanyProfile;
  locations: MatchLocation[];
}
const createMediaResource = (media: MediaProfile, type: 'img' | 'video'): MediaResource => ({
  id: media.resourceId,
  mediaType: type,
  url: media.sourceUrl,
});
export const CompanyDetails = ({companyProfile, locations}: Props) => {
  const {t} = useTranslation('translation', {
    keyPrefix: 'applicantDashboard.matchDetailsView.companyDetails',
  });
  const mediaResources: MediaResource[] = useMemo(() => {
    const media = companyProfile.companyMediaFiles;

    return [
      ...media.videos.map((media) => createMediaResource(media, 'video')),
      ...media.images.map((media) => createMediaResource(media, 'img')),
    ];
  }, [companyProfile]);

  return (
    <Box sx={{padding: {xs: '0px'}, paddingTop: {xs: '0px', sm: '32px'}}} padding='32px'>
      <Grid container display='flex' flexDirection='row'>
        <Grid item md={8} lg={8} xl={8}>
          <CompanySummary companyProfile={companyProfile} />
        </Grid>
        <Grid item md={4} lg={4} xl={4}>
          <CompanyLocations locations={locations} />
        </Grid>
      </Grid>
      <Grid container paddingTop='40px'>
        <CompanyBenefits benefits={companyProfile.benefits} />
      </Grid>
      {mediaResources.length ? (
        <Grid>
          <Typography variant='h3' paddingBottom='16px'>
            {t('media')}
          </Typography>
          <MediaCarousel mediaResources={mediaResources} />
        </Grid>
      ) : null}
    </Box>
  );
};
